import { execute } from '@/api/execute'
import { GET, POST, PUT, DELETE } from '@/api/types'

const ENDPOINT = 'perm/employees'

export default {
  list () {
    return execute(GET, `${ENDPOINT}/`)
  },

  create (payload) {
    return execute(POST, `${ENDPOINT}/create/`, payload)
  },

  getById (id) {
    return execute(GET, `${ENDPOINT}/${id}/`)
  },

  updateById (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/`, payload)
  },

  deleteById (id) {
    return execute(DELETE, `${ENDPOINT}/${id}/`)
  },

  updatePassword (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/password/`, payload)
  }
}
